import { TaxonomyHeader } from './TaxonomyList/TaxonomyHeader.tsx';
import { TaxonomyList } from './TaxonomyList/TaxonomyList.tsx';

export const TaxonomyListPage = () => {
  return (
    <TaxonomyHeader>
      <TaxonomyList />
    </TaxonomyHeader>
  );
};
